export const APP_NAMESPACE = 'App' as const;
